export default __webpack_public_path__ + "static/media/dribbble_logo.513b68f5.png";